<template>
  <div class="container-fluid mycontainer-fluid content">
    <br />
    <a @click="$parent.hidePlan()">&#x025c2; Вернуться к документам</a>
    <br />
    <br />
    <div class="content-title content-mb-14">
      1. Состав оборудования в проекте, планируемого к приобретению
    </div>
    <EquipmentZaim></EquipmentZaim>
    <div class="content-title content-mb-14">
      2. Состав комплектующих и материалов в проекте, планируемых к приобретению
      за счет займа
    </div>
    <EquipmentComponentsMaterials></EquipmentComponentsMaterials>

    <div class="content-title content-mb-14">
      3. РИД, лицензии и патенты, приобретаемые за счёт средств займа
    </div>
    <EquipmentLicensesPatents></EquipmentLicensesPatents>
  </div>
</template>

<script>
import { ProjectsService } from "@/common/api.service";
import { FETCH_DIRECTORY } from "@/store/actions.type";
import UFDopInfo from "@/components/project/form/partial/UFDopInfo";
import EquipmentZaim from "@/components/project/form/partial/EquipmentZaim";
import EquipmentComponentsMaterials from "@/components/project/form/partial/EquipmentComponentsMaterials";
import EquipmentLicensesPatents from "@/components/project/form/partial/EquipmentLicensesPatents";
import { mapGetters } from "vuex";
export default {
  name: "step7",
  components: {
    EquipmentLicensesPatents,
    EquipmentComponentsMaterials,
    EquipmentZaim,
    UFDopInfo
  },
  props: ["project"],

  data() {
    return {
      siteUrl: "",
      FILE_DOCUMENTS_PATH: [],
      showDD: true
    };
  },
  async mounted() {
    await this.$store.dispatch(FETCH_DIRECTORY, ["program_fin_support"]);
    this.getDocInfo();
  },
  methods: {
    getFileName(file) {
      let p = file.split("/");
      return p[p.length - 1];
    },
    getDocInfo() {
      ProjectsService.getDocumentESProjects(2845).then(({ data }) => {
        data.FILE_DOCUMENTS_PATH[14373]
          ? (this.FILE_DOCUMENTS_PATH = data.FILE_DOCUMENTS_PATH[14373])
          : (this.showDD = false);
      }, this);
    },
    stepNumber(num) {
      let steps = {
        12: 12,
        13: 13,
        14: 14
      };

      if (this.programCode(this.project.UF_SUPPORT_PROG_ID) === "evolution") {
        steps = {
          12: 18,
          13: 19,
          14: 20
        };
      }

      if (this.programCode(this.project.UF_SUPPORT_PROG_ID) === "regfond") {
        steps = {
          12: 17,
          13: 18,
          14: 19
        };
      }

      if (this.programCode(this.project.UF_SUPPORT_PROG_ID) === "konversia") {
        steps = {
          12: 18,
          13: 19,
          14: 20
        };
      }

      if (this.programCode(this.project.UF_SUPPORT_PROG_ID) === "stankostroi") {
        steps = {
          12: 18,
          13: 19,
          14: 20
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "complectyushie"
      ) {
        steps = {
          12: 19,
          13: 20,
          14: 21
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) ===
        "complectyushie_rfrp"
      ) {
        steps = {
          12: 19,
          13: 20,
          14: 21
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "priority_program"
      ) {
        steps = {
          12: 25,
          13: 26,
          14: 27
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "auto_components"
      ) {
        steps = {
          12: 20,
          13: 21,
          14: 22
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) ===
        "transport_engineering"
      ) {
        steps = {
          12: 18,
          13: 19,
          14: 20
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) ===
        "providing_mobilization_needs"
      ) {
        steps = {
          12: 13,
          13: 14,
          14: 15
        };
      }

      return steps[num];
    },
    programCode(id) {
      let els = this.directory.program_fin_support.filter(function(el) {
        if (el.ID == id) {
          return true;
        }
        return false;
      }, this);
      if (els.length > 0) {
        return els[0].CODE;
      }
      return "";
    }
  },
  computed: {
    projectDisabled: function() {
      //67080 открыли доступ супервизору
      if (this.project.UF_IS_VIEW_EDIT_CONTROLLER == 1) {
        return false;
      }

      if (
        this.isArchiveProject() ||
        this.project.UF_IS_BLOCK == 1 ||
        this.isAcceptPlan
      ) {
        return true;
      }
      if (
        this.getProgramCode() === "lizing" &&
        this.currentUser.ACTIVE_ROLE_CODE === "users"
      ) {
        return true;
      }

      let t = this.directory.status.filter(
        c => c.ID === this.project.UF_STATUS_ID
      );
      if (t.length) {
        let mc = t[0].IS_MAKE_CHANGE;
        if (mc) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
